import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Kontakt</h3>
          <p><i className="fas fa-phone"></i> +4917666617760</p>
          <p><i className="fas fa-envelope"></i> info@alltagsbegleitung-ckassner.de</p>
          <p><i className="fas fa-clock"></i> Mo-Fr: 8:00 - 18:00</p>
        </div>
        <div className="footer-section">
          <h3>Standort</h3>
          <p><i className="fas fa-map-marker-alt"></i> Willhelm-Külz-Straße 6</p>
          <p>07743 Jena</p>
          <p>Deutschland</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Alltagsbegleitung mit Herz. Alle Rechte vorbehalten.</p>
      </div>
    </footer>
  );
};

export default Footer;
